import { apiJson } from '../_helpers/api';

function get(path) {
  return apiJson('/endpoint/showings' + path);
}

function post(path, body) {
  return apiJson('/endpoint/showings' + path, { method: 'POST', body });
}

export const showingService = {
  activity: () => fetch('/endpoint/showings/activity').then(r => r.json()),
  create: data => post('/', data),
  // opts: { as, status, from, to, state, q, sort, dir }
  mine: opts => {
    const params = new URLSearchParams();
    Object.keys(opts || {}).forEach(k => { if (opts[k]) params.set(k, opts[k]); });
    return get('/mine?' + params.toString());
  },
  jobs: coords =>
    get(coords ? `/jobs?lng=${coords.lng}&lat=${coords.lat}&radius_miles=${coords.radius || 25}` : '/jobs'),
  detail: id => get('/' + id),
  accept: id => post('/' + id + '/accept'),
  setStatus: (id, action, reason) => post('/' + id + '/status', { action, reason }),
  fileReport: (id, report) => post('/' + id + '/report', report),
  review: (id, rating, comment) => post('/' + id + '/review', { rating, comment }),
  myReviews: () => get('/reviews/mine')
};
